<template>
<div class="container">
    <!-- 专业技能 -->
    <section class="group">
        <header>
            <span class="title-line"></span>
            <h2 class="title">专业技能</h2>
            <span class="title-line"></span>
        </header>
        <div class="content">
            <ul class="skill-list">
                <li v-for="(item, index) in skills" :key="index">
                    <i class="iconfont">&#xf28c;</i> {{ item }}
                </li>
            </ul>
        </div>
    </section>
    <!-- 项目经验 -->
    <section class="group">
        <header>
            <span class="title-line"></span>
            <h2 class="title">项目经验</h2>
            <span class="title-line"></span>
        </header>
        <div class="content">
            <div class="item" v-for="(item, index) in project" :key="index">
                <header>
                    <h3 class="item-name">{{ item.name }}</h3>
                    <div>
                        <span class="item-time">{{ item.time }}</span>
                        <a :href="item.href" role='button' target="_blank">link</a>
                    </div>
                </header>
                <div class="item-content">
                    <p class="item-description"><span><i class="iconfont">&#xf28c;</i> 项目描述: </span>{{ item.description }}</p>
                    <p class="item-duty"><span><i class="iconfont">&#xf28c;</i> 项目职责: </span>{{ item.duty }}</p>
                    <p class="item-result"><span><i class="iconfont">&#xf28c;</i> 项目成果: </span>{{ item.result }}</p>
                </div>
            </div>
        </div>
    </section>
    <!-- 在校经历 -->
    <section class="group">
        <header>
            <span class="title-line"></span>
            <h2 class="title">在校经历</h2>
            <span class="title-line"></span>
        </header>
        <div class="content">
            <header>
                <h3>广东工业大学 计算机学院 信息安全 本科</h3>
                <span>2016.09 ~ 2020.07</span>
            </header>
            <p v-for="(item, index) in school" :key="index"><span><i class="iconfont">&#xf28c;</i> {{ item.title }}: </span>{{ item.content }}</p>
        </div>
    </section>
    <!-- 自我评价 -->
    <section class="group">
        <header>
            <span class="title-line"></span>
            <h2 class="title">自我评价</h2>
            <span class="title-line"></span>
        </header>
        <div class="content">
            <ul class="myself-list">
                <li v-for="(item, index) in myself" :key="index">
                    <i class="iconfont">&#xf28c;</i> {{ item }}
                </li>
            </ul>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'ContentLeft',
    data() {
        return {
            skills: [
                '熟悉掌握HTML/CSS3/JS等前端技术,能够理解设计需求并落地,重视用户体验', 
                '熟悉JavaScript核心基础和ES6常用语法, 熟悉Vue主流框架, 了解React', 
                '了解Webpack,使用过Git代码托管工具, 了解常用性能优化方案', 
                '计算机科班出身, 计算机基础扎实, 了解常见安全问题以及防御策略',
                '日常使用Ubuntu, 熟悉Linux, 能够在Linux操作系统环境下进行开发',
            ],
            project: [
                {
                    name: '广工乒俱官网',
                    time: '',
                    href: 'https://brenner8023.github.io/vue-club/#/',
                    description: '基于vue.js和element-ui实现的广工乒乓球俱乐部官网单页面应用',
                    duty: '独立设计并构建编写全部代码,主要使用了vue + vue-router + scss + css3等技术',
                    result: '使用flex/box-shadow/linear-gradient/animation来提升用户体验, 使用vue-router的动态路径参数将某种模式匹配到的所有路由映射到同一组件中, 使用require加载解决webpack打包时图片路径引用问题'
                },
                {
                    name: '2048游戏应用',
                    time: '',
                    href: 'https://brenner8023.github.io/fe-demo/mc-2048/index.html#/',
                    description: '基于vue+vuex实现的2048游戏',
                    duty: '独立设计并构建编写整个页面, 主要使用了vue + vuex + scss + css3等前端技术',
                    result: '实现2048游戏的基本功能, 使用vuex集中式存储管理组件状态, 实现使用localStorage长期保留游戏分数数据'
                },
                {
                    name: 'fe-demo 前端练习',
                    time: '2019.03 ~ 至今',
                    href: 'https://github.com/brenner8023/fe-demo',
                    description: '通过张鑫旭小测任务/技术书籍/前端学习群等教程, 学习总结出来的笔记, 并通过实践制作demo, 使用GitHub Pages进行demo展示',
                    duty: '个人总结, 查漏补缺, 可通过之前的笔记反观以前的自己',
                    result: '纯CSS代码实现轮播动画效果, 自己编写了网页版简历, 手动实现map / reduce / filter等数组API, 还有技术面试文档等'
                },
            ],
            school: [
                {
                    title: '主修课程',
                    content: '数据库 / 操作系统 / 计算机网络 / 数据结构 / 程序设计语言 / 网络安全'
                },
                {
                    title: '社团活动',
                    content: '担任计算机学院乒乓球队队长, 负责团队的管理, 带领团队参加2018年和2019年度广工乒乓球团体锦标赛'
                },
                {
                    title: '社会实践',
                    content: '2016年-2017年于广州班图货运代理公司社会实践'
                },
                {
                    title: '参赛经历',
                    content: '多次参加CTF信息安全赛事, 曾获2017年广工CTF全校第七名'
                }
            ],
            myself: [
                '有良好的编程习惯和编码风格, 对新技术有好奇心, 爱动手实践, 编写demo',
                '喜欢编程, 喜欢开源, 个人维护的一个github项目star数量已达300+',
                '个人性格温和, 易于相处, 有良好的解决问题能力和团队合作精神',
                '拥有良好的自学能力, 喜欢看技术书籍, 浏览技术博客文章',
                '经常在知乎 / GitHub / 知识星球 / B站 / 博客园上活跃, 乐于结识业内人士'
            ]
        }
    }
}
</script>

<style scoped>
.container {
    flex: 6.5;
    padding: 20px 30px 50px;
    box-sizing: border-box;
}
@media screen and (max-width: 1024px) {
    .container {
        flex-grow: 1;
        flex-basis: 100%;
        order: 2;
        padding: 20px 10px 50px;
    }
}

.group {
    padding: 10px 15px;
}

.group header, .content header {
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
header .title-line {
    width: 35%;
    height: 0;
    border-top: 2px solid #eee;
}
header .title {
    width: 24%;
    min-width: 100px;
    padding: 4px 10px;
    border-radius: 32px;
    background: #eee;
    text-align: center;
}
header a[role="button"] {
    padding: 2px 5px;
    color: #00b38a;
    border: 1px solid #00b38a;
    margin-left: 16px;
    text-decoration: none;
    border-radius: 3px;
}
header a[role="button"]:hover {
    color: #fff;
    background: #00b38a;
}

.content {
    padding: 12px 0 5px;
    line-height: 30px;
}

.item {
    margin-bottom: 12px;
}
.item:last-child {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentLeft.vue